import { useMutation, useQueryClient } from '@tanstack/react-query';

import { qrCodeKeys } from '~/constants/queryKeys';

export const useStaticQrUpdateStyles = ({ id, mutationFn }) => {
  const queryClient = useQueryClient();
  const updateQrMutation = useMutation({
    mutationFn,
    onSuccess: (data) => {
      queryClient.setQueryData(qrCodeKeys.qrCodeById(id), (oldData) => ({
        ...oldData,
        data: { ...oldData.data, ...data.data },
      }));
    },
  });

  const onUpdateStaticUrlMutation = (body) => {
    return updateQrMutation.mutate({ id, body });
  };

  const removeImageHandler = () => {
    onUpdateStaticUrlMutation({ embedded_logo_id: null });
  };

  const addImageHandler = ({ embedded_logo_id }) => {
    onUpdateStaticUrlMutation({ embedded_logo_id });
  };

  const updateStylesHandler = (styles) => {
    onUpdateStaticUrlMutation({ style: styles });
  };

  return {
    isProcessing: updateQrMutation.isPending,
    removeImageHandler,
    addImageHandler,
    updateStylesHandler,
  };
};
